import { module } from 'angular';
import { ngModule as foundationDictionaryModule } from 'cg-foundation-dictionary';
import { ContactSalesComponent } from './components/contact-sales';
import { EmailShareComponent } from './components/email-share';
import { LinkShareComponent } from './components/link-share';
import { MissingDeviceComponent } from './components/missing-device';
import { MultipleEmailsDirective } from './directives/multiple-emails';
import { ContactSalesConfigurationService } from './services/contact-sales-configuration';
import { EmailShareConfigurationService } from './services/email-share-configuration';
import { MissingDeviceConfigurationService } from './services/missing-device-configuration';
import '../scss/_master.scss';
export var ngModule = module('gn.audio.cg.forms', [
    'vcRecaptcha',
    'ngSanitize',
    foundationDictionaryModule.name,
])
    .service('contactSalesConfiguration', ContactSalesConfigurationService)
    .service('emailShareConfiguration', EmailShareConfigurationService)
    .service('missingDeviceConfiguration', MissingDeviceConfigurationService)
    .directive('multipleEmails', MultipleEmailsDirective)
    .component('contactSales', ContactSalesComponent)
    .component('emailShare', EmailShareComponent)
    .component('linkShare', LinkShareComponent)
    .component('missingDevice', MissingDeviceComponent);
